import {
  eventsProxy,
  methodsProxy
} from '../../../utils'

const proxyEventMap = [
  'input',
  'change',
  'visible-change',
  'remove-tag',
  'clear',
  'blur',
  'focus'
]

const proxyMethodMap = [
  'focus',
  'blur'
]

export default {
  mounted () {
    eventsProxy(this, this.$refs.select, proxyEventMap)
    methodsProxy(this, this.$refs.select, proxyMethodMap)
  }
}
